import type { PhcPlatformRestEndpoints } from '@lifeomic/phc-web-toolkit/src/hooks/useRestAPIHooks';

export type {
  RegenerativeMedicineLifecycleState,
  RegenerativeMedicineProvenanceStatus,
  RegenerativeMedicineProvenance,
  RegenerativeMedicinePipelineRow,
  RegenerativeMedicinePipelineResponse,
  RegenerativeMedicineEvidence,
  RegenerativeMedicineMemberDetail,
} from '@lifeomic/phc-web-toolkit/src/types/regenerativeMedicineRestEndpoints';

export type RegenerativeMedicinePipelineQuery =
  PhcPlatformRestEndpoints['GET /v1/member-operations/regenerative-medicine/pipeline']['Request'];

export const LIFECYCLE_STATES = [
  'interest_flagged',
  'consult_scheduled',
  'consult_completed',
  'consent_complete',
  'procedure_documented',
  'revenue_captured',
  'post_procedure_followups',
  'not_assessed',
] as const;

export const LIFECYCLE_STEP_ORDER = [
  'interest_flagged',
  'consult_scheduled',
  'consult_completed',
  'consent_complete',
  'procedure_documented',
  'revenue_captured',
  'post_procedure_followups',
] as const;
